import { render, staticRenderFns } from "./gestion_buro_equifax_tablas.vue?vue&type=template&id=6b5586c2"
import script from "./gestion_buro_equifax_tablas.vue?vue&type=script&lang=js"
export * from "./gestion_buro_equifax_tablas.vue?vue&type=script&lang=js"
import style0 from "./gestion_buro_equifax_tablas.vue?vue&type=style&index=0&id=6b5586c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports